/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('CommentsCtrl', ['$scope', 'Comments', 'Account', function ($scope, Comments, Account) {
        
        var comments = { list: [] };
        var currentPage;

        function page(id) {
            currentPage = id;
            return Comments.page(id).then(function (data) { comments.list = data });
        }

        function formOpen(parentId) {
            if (Account.user != null) {
                $scope.formId = parentId;
            } else {
                $scope.$parent.doLogin();
            }
        }

        //properties
        $scope.comments = comments;

        //methods
        $scope.page = page;
        $scope.formOpen = formOpen;

    }]);

    app.controller('CommentCtrl', ['$scope', 'State', 'Comments', 'Account', function ($scope, State, Comments, Account) {

        var state = new State();
        var commentNew = {}; commentNew.user = {};

        function save(form, parentId, currentPage) {
            if (Account.user != null) {
                if (commentNew.text != null) {
                    commentNew.pageId = currentPage;
                    commentNew.user.id = Account.user.id;
                    commentNew.parentId = parentId;
                    if (state.busy()) {
                        Comments.save(commentNew).then(function (response) {
                            $scope.commentNew = {};
                            $scope.formId = undefined;
                            $scope.$parent.comments.list = response;
                            state.success();
                        }, function (error) {
                            state.error(error);
                        });
                    }
                }
            }
            else {
                $scope.$parent.doLogin();
            }
        }

        //properties
        $scope.state = state;
        $scope.commentNew = commentNew;

        //methods
        $scope.save = save;

    }]);

    app.service('Comments', ['$q', 'api', function ($q, api) {

        var service = {
            page: function (id) {
                var deferred = $q.defer();
                api.comment.page(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            save: function (model) {
                var deferred = $q.defer();
                api.comment.save(model).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }
        }
        return service;

    }]);

}());